import { createFileRoute, notFound } from "@tanstack/react-router";

import { deviceModelsQueries } from "@/api/resources/deviceModels/queries";
import { manufacturersQueries } from "@/api/resources/manufacturers/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { CustomInventoryDevicesPage } from "@/components/CustomInventory/CustomInventoryDevicesPage";
import { DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";
import { defaultSortByNameAsc } from "@/utils/pagination";

import type { BreadcrumbsContext } from "@/providers/routerConfig";
import type { QueryFilter } from "@/utils/filter";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/custom-inventory/devices/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.custom-inventory-devices"),
        icon: <Icon.DEVICES />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    await context.queryClient.ensureQueryData(
      manufacturersQueries.listPaginated({
        workspace_ids: [currentWorkspace.id],
        dataTableOptions: {
          ...DEFAULT_DATATABLE_OPTIONS,
          ...defaultSortByNameAsc,
        },
        customFilters: [["workspace_id", "eq", currentWorkspace.id] as QueryFilter],
      }),
    );

    await context.queryClient.ensureQueryData(
      deviceModelsQueries.listPaginated({
        workspace_ids: [currentWorkspace.id],
        dataTableOptions: {
          ...DEFAULT_DATATABLE_OPTIONS,
          ...defaultSortByNameAsc,
        },
        customFilters: [["workspace_id", "eq", currentWorkspace.id] as QueryFilter],
      }),
    );
  },
  component: CustomInventoryDevicesPage,
});
